// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blurSwirl[data-v-43799fd0] {\n  backdrop-filter: blur(1px);\n  -webkit-backdrop-filter: blur(1px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 10;\n}\n", ""]);
// Exports
module.exports = exports;
